function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.78023 37.3345L31.3849 29.0734C31.4859 29.033 31.5397 28.9253 31.4993 28.8176L26.0391 11.676C26.0189 11.575 25.9179 11.5144 25.8102 11.5346C25.763 11.5481 25.7226 11.575 25.6957 11.6154L16.8825 25.4916C16.6873 25.7946 16.3102 25.9225 15.9736 25.8013L0.29978 20.0112C0.198789 19.9775 0.0910635 20.0314 0.0641325 20.1324C0.0506671 20.1727 0.0506685 20.2199 0.0708667 20.267L5.53786 37.1931C5.55805 37.2941 5.66578 37.3547 5.78023 37.3345C5.7735 37.3345 5.7735 37.3345 5.78023 37.3345Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M25.7361 8.24244L30.9405 0.984546C30.9944 0.876822 30.954 0.742171 30.8463 0.688309C30.8059 0.66811 30.7655 0.661377 30.7184 0.661377L5.69949 8.73394C5.49077 8.80127 5.32245 8.94266 5.21473 9.13117L0.0170481 16.3554C-0.0300811 16.4699 0.023781 16.5978 0.138238 16.6382C0.171901 16.6516 0.212299 16.6584 0.252696 16.6516L25.3254 8.55889C25.5005 8.50502 25.6419 8.39057 25.7361 8.24244Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M1.57907 18.577L15.2533 23.6333C15.5899 23.7545 15.9669 23.6266 16.1622 23.3236L23.7163 11.4269C23.7702 11.3192 23.7298 11.1845 23.6221 11.1306C23.5817 11.1104 23.5413 11.1037 23.5009 11.1104L1.56561 18.1865C1.45788 18.2471 1.41749 18.3751 1.47808 18.4828C1.49828 18.5232 1.53194 18.5568 1.57907 18.577Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M27.0827 9.58221L32.819 27.5923C32.8392 27.6933 32.9402 27.7606 33.0412 27.7337C33.095 27.7202 33.1422 27.6866 33.1691 27.6327L38.6024 19.9574C38.6967 19.7756 38.7102 19.5601 38.6496 19.3649L32.9469 1.7251C32.92 1.6241 32.819 1.56351 32.718 1.5837C32.6709 1.59717 32.6372 1.6241 32.6103 1.65776L27.1298 9.40042C27.0827 9.46102 27.0692 9.52161 27.0827 9.58221Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M16.8826 25.4918L25.6621 11.6358C25.7227 11.5348 25.8573 11.4944 25.965 11.5617C26.0122 11.5887 26.0526 11.6425 26.066 11.6964L27.0086 14.7463L16.8826 25.4918Z",
  fill: "white"
});

function SvgBoxesShortWhiteLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 38,
    viewBox: "0 0 145 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxesShortWhiteLogo);
export default __webpack_public_path__ + "static/media/boxes-short-white-logo.8a87d98b.svg";
export { ForwardRef as ReactComponent };